const routerArr = [
    {
        path: '/servicePay',
        name: 'servicePay',
        meta: { title:'服务费确认' , login:false },
        component: () => import(/* webpackChunkName: 'mh_homepage' */ './page/servicePay.vue'),
    }
]

export default routerArr;